var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from "@atlassiansox/microscopekit";
import { usePageVisibility } from "react-page-visibility";
export function usePollingQuery(query, options, isPollingEnabled) {
    if (isPollingEnabled === void 0) { isPollingEnabled = true; }
    var isPageVisible = usePageVisibility();
    var shouldPoll = isPollingEnabled && isPageVisible;
    return useQuery(query, __assign(__assign({}, options), { pollInterval: shouldPoll ? 10000 : 0 }));
}
